'use client'

import Stack from '@mui/material/Stack'
import Container from '@mui/material/Container'
import * as React from 'react'
import Box from '@mui/material/Box'
import { Button, Typography } from '@mui/material'
import Link from 'next/link'
import { Logo } from '@/components/Logo'

function Page() {
  return (
    <Container maxWidth="xl">
      <Stack alignItems="center" height="100vh" width="100%">
        <Box sx={{ mt: 6, mb: 6 }}>
          <Logo />
        </Box>
        <Box flexGrow={1}>
          <Stack alignItems="center" spacing={2}>
            <Typography variant="h2">PBLWorks Publisher</Typography>
            <Typography>
              Manage PBLWorks resources, project units, lessons and training
              material.
            </Typography>
            <Button component={Link} href="/projects" variant="contained">
              Go to the app
            </Button>
          </Stack>
        </Box>
      </Stack>
    </Container>
  )
}

// eslint-disable-next-line import/no-default-export -- Next.js default policy
export default Page
